'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { useSession } from '@cntxt/shared/infrastructure/session';
import { LegacyAppLayout } from '@cntxt/shared/ui/layouts';
import Loading from './loading';
export function MainApp(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    data
  } = useSession();
  if (!data) {
    return children;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Loading />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <LegacyAppLayout><React.Suspense fallback={t1}>{children}</React.Suspense></LegacyAppLayout>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}